import React from "react";
import { Navigate, useParams } from "react-router-dom";
import { useRouteCourse } from "../../hooks/useRouteCourse";
import { LessonRunner } from "../../components/games/LessonRunner";
interface LessonProps {
  practice?: boolean;
}
export function Lesson({
  practice = false
}: LessonProps) {
  const {
    lessonId = ""
  } = useParams();
  const course = useRouteCourse();
  if (!course) return <Navigate to="/app/courses" replace data-id="element-1335" data-mp="3szelgsirsj99" />;
  return <LessonRunner key={`${course.id}:${practice ? "practice" : lessonId}`} course={course} lessonId={lessonId} practice={practice} data-id="element-1336" data-mp="3sy4lfxscx0zz" />;
}